import React from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import { Cookie, Settings, BarChart, Shield } from 'lucide-react';

const Cookies = () => {
  return (
    <div className="min-h-screen bg-gray-900">
      <Header />
      <main className="py-12 md:py-20">
        <div className="container mx-auto px-4">
          <div className="max-w-4xl mx-auto">
            <article className="bg-gray-800 rounded-2xl p-8 md:p-12 border border-gray-700">
              <h1 className="text-4xl md:text-5xl font-bold text-white mb-6">
                Politique des Cookies
              </h1>
              <p className="text-gray-400 text-sm mb-8">
                Dernière mise à jour : 26 novembre 2025
              </p>
              
              <div className="prose prose-invert max-w-none">
                <p className="text-lg text-gray-300 mb-8 leading-relaxed">
                  Cette Politique des Cookies explique ce que sont les cookies, comment nous les utilisons sur notre site galo-bet.com, et comment vous pouvez contrôler leur utilisation. En continuant à utiliser notre Site, vous acceptez l'utilisation de cookies conformément à cette politique.
                </p>

                <section className="mb-10">
                  <h2 className="text-3xl font-bold text-white mb-4 flex items-center space-x-2">
                    <Cookie className="text-pink-400" size={28} />
                    <span>1. Qu'est-ce qu'un Cookie ?</span>
                  </h2>
                  <p className="text-gray-300 leading-relaxed mb-4">
                    Un cookie est un petit fichier texte qui est stocké sur votre appareil (ordinateur, tablette, smartphone) lorsque vous visitez un site web. Les cookies permettent au site de reconnaître votre appareil et de mémoriser certaines informations sur vos préférences ou vos actions passées.
                  </p>
                  <p className="text-gray-300 leading-relaxed mb-4">
                    Les cookies ne peuvent pas endommager votre appareil ni contenir de virus. Ils sont largement utilisés pour faire fonctionner les sites web de manière plus efficace et pour fournir des informations aux propriétaires du site.
                  </p>
                </section>

                <section className="mb-10">
                  <h2 className="text-3xl font-bold text-white mb-4 flex items-center space-x-2">
                    <Settings className="text-pink-400" size={28} />
                    <span>2. Comment Nous Utilisons les Cookies</span>
                  </h2>
                  <p className="text-gray-300 leading-relaxed mb-4">
                    Nous utilisons des cookies pour plusieurs raisons :
                  </p>
                  <ul className="text-gray-300 space-y-2 ml-6 mb-4">
                    <li><strong>Cookies strictement nécessaires :</strong> Ces cookies sont essentiels pour vous permettre de naviguer sur le Site et d'utiliser ses fonctionnalités de base. Sans ces cookies, certains services que vous demandez ne peuvent pas être fournis.</li>
                    <li><strong>Cookies de performance :</strong> Ces cookies collectent des informations sur la façon dont vous utilisez notre Site, comme les pages que vous visitez le plus souvent. Ces données nous aident à améliorer le fonctionnement du Site.</li>
                    <li><strong>Cookies de fonctionnalité :</strong> Ces cookies permettent au Site de se souvenir de vos choix (comme votre langue préférée) et de fournir des fonctionnalités améliorées et personnalisées.</li>
                    <li><strong>Cookies de ciblage :</strong> Ces cookies peuvent être définis par nos partenaires publicitaires pour créer un profil de vos intérêts et vous afficher des publicités pertinentes sur d'autres sites.</li>
                  </ul>
                </section>

                <section className="mb-10">
                  <h2 className="text-3xl font-bold text-white mb-4 flex items-center space-x-2">
                    <BarChart className="text-pink-400" size={28} />
                    <span>3. Types de Cookies Utilisés</span>
                  </h2>
                  <div className="bg-gray-700 rounded-lg p-6 mb-4">
                    <h3 className="text-white font-semibold mb-3">Cookies de Première Partie</h3>
                    <p className="text-gray-300 text-sm mb-4">
                      Ces cookies sont définis directement par notre Site. Ils sont essentiels au fonctionnement du Site et incluent :
                    </p>
                    <ul className="text-gray-300 text-sm space-y-1 ml-4">
                      <li>• Cookies de session pour maintenir votre session active</li>
                      <li>• Cookies de préférences pour mémoriser vos choix</li>
                      <li>• Cookies de sécurité pour protéger contre les attaques</li>
                    </ul>
                  </div>
                  <div className="bg-gray-700 rounded-lg p-6 mb-4">
                    <h3 className="text-white font-semibold mb-3">Cookies de Tiers</h3>
                    <p className="text-gray-300 text-sm mb-4">
                      Ces cookies sont définis par des domaines autres que le nôtre. Nous pouvons utiliser des services tiers qui placent leurs propres cookies. Ces cookies incluent :
                    </p>
                    <ul className="text-gray-300 text-sm space-y-1 ml-4">
                      <li>• Cookies d'analyse (Google Analytics) pour comprendre comment les visiteurs utilisent notre Site</li>
                      <li>• Cookies publicitaires pour personnaliser les publicités</li>
                      <li>• Cookies de réseaux sociaux si vous partagez notre contenu</li>
                    </ul>
                  </div>
                </section>

                <section className="mb-10">
                  <h2 className="text-3xl font-bold text-white mb-4">4. Durée de Conservation</h2>
                  <p className="text-gray-300 leading-relaxed mb-4">
                    Les cookies que nous utilisons ont des durées de vie différentes :
                  </p>
                  <ul className="text-gray-300 space-y-2 ml-6 mb-4">
                    <li><strong>Cookies de session :</strong> Ces cookies sont temporaires et sont supprimés lorsque vous fermez votre navigateur.</li>
                    <li><strong>Cookies persistants :</strong> Ces cookies restent sur votre appareil pendant une période déterminée ou jusqu'à ce que vous les supprimiez manuellement. La durée de conservation maximale est de 13 mois conformément à la réglementation française.</li>
                  </ul>
                </section>

                <section className="mb-10">
                  <h2 className="text-3xl font-bold text-white mb-4 flex items-center space-x-2">
                    <Shield className="text-pink-400" size={28} />
                    <span>5. Gestion des Cookies</span>
                  </h2>
                  <p className="text-gray-300 leading-relaxed mb-4">
                    Vous avez le contrôle total sur les cookies. La plupart des navigateurs web acceptent automatiquement les cookies, mais vous pouvez modifier les paramètres de votre navigateur pour refuser les cookies si vous le souhaitez. Voici comment procéder pour les principaux navigateurs :
                  </p>
                  <ul className="text-gray-300 space-y-2 ml-6 mb-4">
                    <li><strong>Google Chrome :</strong> Paramètres → Confidentialité et sécurité → Cookies et autres données de sites</li>
                    <li><strong>Mozilla Firefox :</strong> Options → Vie privée et sécurité → Cookies et données de sites</li>
                    <li><strong>Safari :</strong> Préférences → Confidentialité → Cookies et données de sites web</li>
                    <li><strong>Microsoft Edge :</strong> Paramètres → Confidentialité, recherche et services → Cookies</li>
                  </ul>
                  <p className="text-gray-300 leading-relaxed mb-4">
                    <strong>Important :</strong> Si vous choisissez de désactiver les cookies, certaines fonctionnalités de notre Site peuvent ne pas fonctionner correctement. Par exemple, vos préférences ne seront pas mémorisées et vous devrez peut-être vous reconnecter ou reconfigurer certains paramètres à chaque visite.
                  </p>
                </section>

                <section className="mb-10">
                  <h2 className="text-3xl font-bold text-white mb-4">6. Cookies de Tiers et Liens d'Opt-Out</h2>
                  <p className="text-gray-300 leading-relaxed mb-4">
                    Certains cookies tiers que nous utilisons peuvent être gérés via les sites web des fournisseurs de services. Par exemple :
                  </p>
                  <ul className="text-gray-300 space-y-2 ml-6 mb-4">
                    <li><strong>Google Analytics :</strong> Vous pouvez refuser les cookies Google Analytics en téléchargeant le module complémentaire de navigateur disponible sur le site de Google.</li>
                    <li><strong>Réseaux sociaux :</strong> Les cookies des réseaux sociaux peuvent être gérés via les paramètres de votre compte sur chaque plateforme respective.</li>
                  </ul>
                </section>

                <section className="mb-10">
                  <h2 className="text-3xl font-bold text-white mb-4">7. Consentement aux Cookies</h2>
                  <p className="text-gray-300 leading-relaxed mb-4">
                    Lors de votre première visite sur notre Site, nous vous demandons votre consentement pour l'utilisation de cookies non essentiels via une bannière d'information. Vous pouvez accepter ou refuser ces cookies.
                  </p>
                  <p className="text-gray-300 leading-relaxed mb-4">
                    Vous pouvez modifier vos préférences de cookies à tout moment en cliquant sur le lien "Gérer les cookies" dans le pied de page de notre Site ou en modifiant les paramètres de votre navigateur.
                  </p>
                </section>

                <section className="mb-10">
                  <h2 className="text-3xl font-bold text-white mb-4">8. Mises à Jour de Cette Politique</h2>
                  <p className="text-gray-300 leading-relaxed mb-4">
                    Nous pouvons mettre à jour cette Politique des Cookies de temps à autre pour refléter les changements dans notre utilisation des cookies ou pour d'autres raisons opérationnelles, légales ou réglementaires. Toute modification sera publiée sur cette page avec une mise à jour de la date de "dernière mise à jour".
                  </p>
                </section>

                <section className="mb-10">
                  <h2 className="text-3xl font-bold text-white mb-4">9. Contact</h2>
                  <p className="text-gray-300 leading-relaxed mb-4">
                    Pour toute question concernant notre utilisation des cookies, vous pouvez nous contacter :
                  </p>
                  <div className="bg-gray-700 rounded-lg p-6 mb-4">
                    <p className="text-gray-300 mb-2"><strong>Email :</strong> <a href="mailto:info@galo-bet.com" className="text-pink-400 hover:text-pink-300">info@galo-bet.com</a></p>
                    <p className="text-gray-300 mb-2"><strong>Téléphone :</strong> <a href="tel:+33519286219" className="text-pink-400 hover:text-pink-300">+33 5 19 28 62 19</a></p>
                    <p className="text-gray-300"><strong>Adresse :</strong> Paris, France</p>
                  </div>
                </section>
              </div>
            </article>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default Cookies;

